/* eslint-disable @typescript-eslint/no-explicit-any */
import { IconTrendingDown, IconTrendingUp } from "@tabler/icons-react"

import { Badge } from "@/components/ui/badge"
import {
  Card,
  CardAction,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { isAdmin } from "@/services/userService";

export function SectionCards({data}:{data:any}) {
  const date = new Date()
  const month = date.toLocaleString("default", { month: "long" })
  const userIsAdmin = isAdmin();
  return (
    <div className="*:data-[slot=card]:from-primary/5 *:data-[slot=card]:to-card dark:*:data-[slot=card]:bg-card grid grid-cols-1 gap-4 px-4 *:data-[slot=card]:bg-gradient-to-t *:data-[slot=card]:shadow-xs lg:px-6 @xl/main:grid-cols-2 @5xl/main:grid-cols-4">
      
      {userIsAdmin && 
        <Card className="@container/card">
          <CardHeader>
            <CardDescription>Total Documents</CardDescription>
            <CardTitle className="text-2xl font-semibold tabular-nums @[250px]/card:text-3xl">
              {data?.documentCount || 0}
            </CardTitle>
            <CardAction>
              <Badge variant="outline">
                <IconTrendingUp />
                +12.5%
              </Badge>
            </CardAction>
          </CardHeader>
          <CardFooter className="flex-col items-start gap-1.5 text-sm">
            <div className="line-clamp-1 flex gap-2 font-medium">
              All records available in the system
            </div>
            <div className="text-muted-foreground">
              This shows the total number of documents uploaded or maintained across the entire system, including all users and case types.
            </div>
          </CardFooter>
        </Card>
      }
      <Card className="@container/card">
        <CardHeader>
          <CardDescription>My Documents</CardDescription>
          <CardTitle className="text-2xl font-semibold tabular-nums @[250px]/card:text-3xl">
            {data?.userDocumentCount || 0}
          </CardTitle>
          <CardAction>
            <Badge variant="outline">
              <IconTrendingDown />
              -20%
            </Badge>
          </CardAction>
        </CardHeader>
        <CardFooter className="flex-col items-start gap-1.5 text-sm">
          <div className="line-clamp-1 flex gap-2 font-medium">
            Documents added or assigned to you
          </div>
          <div className="text-muted-foreground">
            Displays the number of documents specifically associated with your account—either uploaded by you or assigned to you for action.
          </div>
        </CardFooter>
      </Card>
      {!userIsAdmin && 
        <Card className="@container/card">
          <CardHeader>
            <CardDescription>My General Diaries</CardDescription>
            <CardTitle className="text-2xl font-semibold tabular-nums @[250px]/card:text-3xl">
              {data?.userGeneralDiaryCount || 0}
            </CardTitle>
            <CardAction>
              <Badge variant="outline">
                <IconTrendingDown />
                -20%
              </Badge>
            </CardAction>
          </CardHeader>
          <CardFooter className="flex-col items-start gap-1.5 text-sm">
            <div className="line-clamp-1 flex gap-2 font-medium">
              General diary added or assigned to you
            </div>
            <div className="text-muted-foreground">
              Displays the number of general diary specifically associated with your account—either uploaded by you or assigned to you for action.
            </div>
          </CardFooter>
        </Card>
      }
      <Card className="@container/card">
        <CardHeader>
          <CardDescription>Total Users</CardDescription>
          <CardTitle className="text-2xl font-semibold tabular-nums @[250px]/card:text-3xl">
            {data?.userCount || 0}
          </CardTitle>
          <CardAction>
            <Badge variant="outline">
              <IconTrendingUp />
              +12.5%
            </Badge>
          </CardAction>
        </CardHeader>
        <CardFooter className="flex-col items-start gap-1.5 text-sm">
          <div className="line-clamp-1 flex gap-2 font-medium">
            All registered users 
          </div>
          <div className="text-muted-foreground">Shows the total count of users registered, providing a complete overview of such details across the system.</div>
        </CardFooter>
      </Card>
      <Card className="@container/card">
        <CardHeader>
          <CardDescription> {month} Documents</CardDescription>
          <CardTitle className="text-2xl font-semibold tabular-nums @[250px]/card:text-3xl">
            {userIsAdmin ? (data?.documentCountThisMonth || 0) : (data.userDocumentCountThisMonth || 0)}
          </CardTitle>
          <CardAction>
            <Badge variant="outline">
              <IconTrendingUp />
              +4.5%
            </Badge>
          </CardAction>
        </CardHeader>
        <CardFooter className="flex-col items-start gap-1.5 text-sm">
          <div className="line-clamp-1 flex gap-2 font-medium">
            New documents added this month
          </div>
          <div className="text-muted-foreground">Indicates how many preventive cases (170/126/135) were filed during the current month, helping track recent activity and trends.</div>
        </CardFooter>
      </Card>
    </div>
  )
}
